import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
//import Logo from "../../assets/FullLogo_Transparent_NoBuffer (3).png";
import Logo from "../../assets/FullLogo_NoBuffer__4_-removebg-preview.png";
import { useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom"
import { driverSelector, logOut, logout } from '../../api/driver';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-daisyui';
import { Headset } from 'lucide-react';
import { config } from '../../key';


const HamburgerMenu = ({ isOpen, toggle }) => {
  return (
    <button
      onClick={toggle}
      aria-label={isOpen ? "Close menu" : "Open menu"}
      className="relative w-9 h-8 flex flex-col justify-center items-center group focus:outline-none"
    >
      {/* Hamburger animated lines */}
      <span
        className={`block h-0.5 w-6 bg-gray-800 rounded transform transition duration-300 ease-in-out origin-center ${
          isOpen ? "rotate-45 translate-y-2" : ""
        }`}
      ></span>
      <span
        className={`block h-0.5 w-6 bg-gray-800 rounded mt-1.5 transition duration-300 ease-in-out ${
          isOpen ? "opacity-0" : "opacity-100"
        }`}
      ></span>
      <span
        className={`block h-0.5 w-6 bg-gray-800 rounded mt-1.5 transform transition duration-300 ease-in-out origin-center ${
          isOpen ? "-rotate-45 -translate-y-2" : ""
        }`}
      ></span>

      <style>{`
        button:focus {
          box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.6);
          outline: none;
          border-radius: 0.375rem;
        }
      `}</style>
    </button>
  );
};

export const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setuser] = useState({});
  const [authStatus, setAuthStatus] = useState(null);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null);
  const { driverAuthenticate } = useSelector(driverSelector)
  console.log(driverAuthenticate);
  const dispatch = useDispatch()

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  // PWA prompt state
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);

   // Handle PWA install prompt event
  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  useEffect(() => {
  // Detect when app is installed
  const handleAppInstalled = () => {
    console.log("App already installed");
    setShowInstallButton(false); // Hide the button
  };

  window.addEventListener("appinstalled", handleAppInstalled);

  return () => {
    window.removeEventListener("appinstalled", handleAppInstalled);
  };
}, []);

const isAppInstalled = () => {
  return (
    window.matchMedia("(display-mode: standalone)").matches || // Chrome, Edge
    window.navigator.standalone === true // iOS Safari
  );
};

 const handleInstallClick = async () => {
    if (isAppInstalled()) {
    alert("✅ App is already installed on your device!");
    return;
  }
  if (deferredPrompt) {
    // ✅ Standard PWA install (works in Chrome, Edge, etc.)
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setIsMenuOpen(false);
  } else if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
    // ✅ iOS Safari fallback
    alert("To install this app, tap Share → Add to Home Screen");
  } else {
    // ✅ Other unsupported browsers
    alert("Your browser doesn’t support direct install. Please bookmark this page.");
  }
};



  useEffect(() => {
    axios
      .get("http://localhost:5000/auth/user", { withCredentials: true })
      .then((response) => {
        setuser(response.data.user)
        console.log("Whole Response", response.data.authenticated);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [])


  useEffect(() => {
    const fetchAuthStatus = async () => {
      try {
        const response = await axios.get('http://localhost:5000/auth/check-auth', { withCredentials: true } );
        setAuthStatus(response.data.authenticated);
        setUserData(response.data.user);
        setError(null);
      } catch (err) {
        setAuthStatus(false);
        setUserData(null);
        setError(err.response?.data?.message || 'An error occurred');
      }
    };

    fetchAuthStatus();
  }, []);
  console.log(user)
  const profilepic = user?._json?.picture
  console.log(profilepic)




  const loginUser = () => {
    console.log("login triggered");
    navigate("/signup")
  }


  const handlehelp = () => {
    console.log("Help clicked")
    window.location.href = `tel:+910000000000`;
  }
  const logoutUser = async () => {
    dispatch(logOut());
    console.log("Logout triggered");

    try {
      const response = await axios.get("http://localhost:5000/auth/logout", {
        withCredentials: true, // Include cookies if your authentication uses them
      });
      localStorage.clear();
      dispatch(logout());
      // navigate("/home")
      console.log("Whole Response:", response);
      // setAuthStatus(false);

      navigate("/")

      if (response.status === 200) {
        setuser(null); // Clear the user state or handle logout accordingly
        console.log("Logout successful!")

      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };


  return (
    <div className='w-full top-0 z-50 bg-gray-50   '>
      <div className="px-4 py-5 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div className="relative flex grid items-center grid-cols-2 lg:grid-cols-3 st">
          <ul className="flex items-center hidden space-x-8 lg:flex">
            <li>
              {/* <Link
                to={authStatus || driverAuthenticate ? "/profile" : "/product"}
                aria-label={authStatus || driverAuthenticate ? "Your Profile" : "Our Product"}
                title={authStatus || driverAuthenticate ? "Your Profile" : "Our Product"}
                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                {authStatus || driverAuthenticate ? "Profile" : "Product"}
              </Link> */}
            </li>
            <li>
              {/* <Link
                to={authStatus || driverAuthenticate ? "/cafes" : "/features"}
                aria-label={authStatus || driverAuthenticate ? "Cafes" : "Features"}
                title={authStatus || driverAuthenticate ? "Cafes" : "Features"}
                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                {authStatus || driverAuthenticate ? "Cafes" : "Features"}
              </Link> */}
            </li>
            <li>
              {/* <Link
                to={authStatus || driverAuthenticate ? "/collabs" : "/pricing"}
                aria-label={authStatus || driverAuthenticate ? "Collaborations" : "Product pricing"}
                title={authStatus || driverAuthenticate ? "Collaborations" : "Product pricing"}
                className="font-medium tracking-wide text-gray-700 transition-colors duration-200 hover:text-deep-purple-accent-400"
              >
                {authStatus || driverAuthenticate ? "Collabs" : "AboutUs "}
              </Link> */}
            </li>
          </ul>
          <Link
            to="/"
            aria-label="StarSync"
            title="StarSync"
            className="inline-flex items-center lg:mx-auto"
          >

            <img src={Logo} className='w-26 h-14'></img>

          </Link>
          <ul className="flex items-center hidden ml-auto space-x-8 lg:flex">
              <li>
              <Link
                to="/"
                aria-label="Home"
                title="Home"
                className={`font-medium tracking-wide text-black transition-colors duration-200 hover:text-deep-purple-accent-400 ${authStatus || driverAuthenticate ? 'hidden' : ""
                  }`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/signin"
                aria-label="Sign in"
                title="Sign in"
                className={`font-medium tracking-wide text-black transition-colors duration-200 hover:text-deep-purple-accent-400 ${authStatus || driverAuthenticate ? 'hidden' : ""
                  }`}
              >
                Sign In
              </Link>
            </li>
            <li>
              {/* <Link
                onClick={()=>{
                  authStatus ? logoutUser() : loginUser()

                }}
                className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-black transition duration-200 rounded shadow-md bg-purple-400 hover:bg-purple-700 focus:shadow-outline focus:outline-none"
                aria-label="Sign up"
                title="Sign up"
              >
                {
                  authStatus ? "Logut" : "Sign in"
                }
              </Link> */}
              <button
                className="inline-flex items-center justify-center h-12 px-6 font-medium tracking-wide text-black transition duration-200 rounded shadow-md bg-[#3B82F7] hover:[#0223f5] focus:shadow-outline focus:outline-none"
                onClick={() => {
                  // Trigger the action based on authStatus
                  driverAuthenticate || authStatus ? logoutUser() : loginUser();
                }}
                aria-label="Sign up"
                title="Sign up"
              >

                {authStatus || driverAuthenticate ? "Logout" : "Register"}

              </button>

            </li>
          </ul>
         <div className="ml-auto lg:hidden flex items-center gap-4 relative">
     
     
      {/* Hamburger */}
      <div className="lg:hidden px-2 pt-4">
        <HamburgerMenu isOpen={isMenuOpen} toggle={toggleMenu} />
      </div>

      {/* Menu */}
      {isMenuOpen && (
        <div className="absolute top-full right-0 mt-2 w-40 mr-2 bg-white border border-gray-300 rounded-lg shadow-lg z-50 animate-fade-in">
          <ul className="flex flex-col p-3 space-y-3 text-gray-700">
            <li>
              <button className="w-full text-left px-4 py-1 rounded-md hover:bg-indigo-600 hover:text-white transition" onClick={handlehelp}>
                Help
              </button>
            </li>
            <li>
              <button className="w-full text-left px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 transition" onClick={handleInstallClick}>
                Install App
              </button>
            </li>
          </ul>
        </div>
      )}
      
    </div>
        </div>
      </div></div>
  );
};

export default Nav